import * as React from 'react';

export interface ISignIn {
  signIn: () => void;
  className?: string;
}

class SignInGoogle extends React.Component<ISignIn> {
  constructor(props: ISignIn) {
    super(props);
  }

  public render() {
    const { signIn } = this.props;
    return (
      <img src="../../../../assets/images/google-icon.png" onClick={signIn} style={{cursor: 'pointer'}}/>
    );
  }
}

export { SignInGoogle };
